import { getAllCategories } from './categories';
import { QUESTION_CATALOG } from './catalog.generated';
import { isCategoryLive } from './catalog';
import { isOffensive } from './names';
// Topic requests ("add Formula 1!"). Shared so the app and server agree on
// what counts as the same topic.
export const TOPIC_MIN_LENGTH = 2;
export const TOPIC_MAX_LENGTH = 40;
// A topic is only suggested to other players once this many people asked for
// it, so one person's typo (or worse) never shows up for everyone.
export const TOPIC_PUBLIC_VOTES = 2;
// Lowercase words only: "Formula-1!!" and "formula 1" are the same request.
export function topicKey(topic) {
    return topic
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim()
        .replace(/^the /, '');
}
export function cleanTopic(topic) {
    const cleaned = topic.replace(/[\u0000-\u001F\u007F​-‏‪-‮⁠-⁤﻿]/g, '').replace(/\s+/g, ' ').trim();
    if (cleaned.length < TOPIC_MIN_LENGTH || cleaned.length > TOPIC_MAX_LENGTH)
        return null;
    if (!/\p{L}/u.test(cleaned) || topicKey(cleaned).length < TOPIC_MIN_LENGTH || isOffensive(cleaned))
        return null;
    return cleaned;
}
// "chess" -> the Chess category; "cricket" -> the Cricket theme in Sports.
// Lets the app say "that's already here" instead of logging a request.
export function findExistingTopic(text) {
    const key = topicKey(text);
    if (key.length < 3)
        return null;
    const pad = (s) => ` ${s} `;
    for (const c of getAllCategories()) {
        if (!isCategoryLive(c.key))
            continue;
        if (topicKey(c.title) === key || topicKey(c.key) === key)
            return { category: c.key };
    }
    for (const c of getAllCategories()) {
        if (!isCategoryLive(c.key))
            continue;
        for (const theme of Object.keys(QUESTION_CATALOG[c.key]?.themes ?? {})) {
            const t = topicKey(theme);
            if (t === key || (key.length >= 4 && pad(t).includes(pad(key))))
                return { category: c.key, theme };
        }
    }
    for (const c of getAllCategories()) {
        if (!isCategoryLive(c.key))
            continue;
        if (key.length >= 4 && pad(topicKey(c.title)).includes(pad(key)))
            return { category: c.key };
    }
    return null;
}
